//https://chakra-ui.com/guides/theming-change-default-color-palette
import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react"

const config = defineConfig({
  theme: {
    tokens: {
      colors: {
        grackle: {
           50: { value: "#fcfcae" },
          100: { value: "#fcfcae" },
          200: { value: "#fcfcae" },
          300: { value: "#04f5cf" },
          400: { value: "#04f5cf" },
          500: { value: "#20d4f8" },
          600: { value: "#209af8ff" },
          700: { value: "#9a80f4" },
          800: { value: "#9a80f4" },
          900: { value: "#083571" },
          950: { value: "#083571" },
        },
      },
    },
    semanticTokens: {
      colors: {
        grackle: {
          solid: { value: "{colors.grackle.950}" },
          contrast: { value: "{colors.grackle.100}" },
          fg: { value: "{colors.grackle.300}" },
          muted: { value: "{colors.grackle.100}" },
          subtle: { value: "{colors.grackle.500}" },
          emphasized: { value: "{colors.brand.700}" },
          focusRing: { value: "{colors.brand.700}" },
        },
      },
    },
  },
  globalCss: {
    "Container": {
      bg: "{colors.grackle.900}"
    },
    "Input": {
      bg:  "{colors.grackle.700}",
      color:  "{colors.grackle.200}",
      _hover: {
        borderColor: "{colors.grackle.400}", 
        borderWidth: "2px"
      },
    }
  }
})

export const system = createSystem(defaultConfig, config)